<template>
    <el-row :gutter="20" class="main_block">
        <div class="mianContent">
            <div class="tagView">
                <div class="title_aside"></div>
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item>{{
                        $route.meta.title
                    }}</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
            <div class="search">
                <el-form
                    :model="searchParam"
                    status-icon
                    ref="searchData"
                    label-position="left"
                    label-width="90px"
                    :inline="true"
                >
                    <el-form-item label="">
                        <el-date-picker
                            v-model="dataVal"
                            type="datetimerange"
                            align="right"
                            unlink-panels
                            @change="datetime"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            format="yyyy-MM-dd"
                            value-format="timestamp"
                            :default-time="['00:00:00', '23:59:59']"
                            :picker-options="pickerOptions"
                        >
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="">
                        <el-input
                            type="text"
                            v-model="searchParam.username"
                            autocomplete="off"
                            placeholder="请输入子账号"
                        ></el-input>
                    </el-form-item>
                    
                    <el-form-item label="">
                        <el-button
                            type="primary"
                            @click="selectTable"
                            >查询</el-button
                        >
                        <el-button
                            type="info"
                            @click="dataVal='',
                                (dataVal1='',searchParam = {},pageSizeNum=10),
                                    selectTable()
                            "
                            >重置</el-button
                        >
                    </el-form-item>
                </el-form>
            </div>
            <ExTable
                :stripe="false"
                :select="false"
                :isIndex="false"
                :table-list="tableData"
                :header="header"
                height="300"
                :total="total"
                :tableId="2"
                :activeIndex="searchParam.page"
                :spanMethod="tableSpanMethod"
                :pageSizeNum="pageSizeNum"
                @clickPage="clickPage"
                @clickSize="clickSize"
            />
            <div class="tsCount" style="font-size：14px;color:#999;margin-top:-26px">
                共消费时间戳：<span style="font-size:16px;color:#409EFF">{{tsCount}}</span> 个
            </div>
        </div>
    </el-row>
</template>

<script>
import ExTable from "@com/ExTable";
import { formatDate, sourceType,filterParams } from "@/utils/filter";
import {getChildrenOverview,getConsumeTsCount} from "@http/sub_account/index";
export default {
    data() {
        return {
            tsCount:0,
            page: 1,
            size: 10,
            dataVal:'',
            searchParam: {
                username: '',
                startCreatedAt: "",
                endCreatedAt: "",
            },
            pageSizeNum:10,
            tableData: [],
            header: [
                {
                    prop: "username",
                    label: "账号",
                    minWidth:120,
                },
                {
                    prop: "name",
                    label: "账号所有人",
                    minWidth:120,
                },
                {
                    minWidth:210,
                    label: "联系方式",
                    render: (h, data) => {
                        if(!data.row.contractPhone && !data.row.contractEmail){
                            return (
                                <div>--</div>
                            )
                        }else if(data.row.contractPhone && data.row.contractEmail){
                            return (
                                <ul>
                                    <li>
                                        电话：{data.row.contractPhone}
                                    </li> 
                                    <li>
                                        邮箱：{data.row.contractEmail}
                                    </li> 
                                </ul>
                            )
                        }else if(!data.row.contractPhone && data.row.contractEmail){
                            return (
                                <ul>
                                    <li>
                                        邮箱：{data.row.contractEmail}
                                    </li> 
                                </ul>
                            )
                        }else if(data.row.contractPhone && !data.row.contractEmail){
                            return (
                                <ul>
                                    <li>
                                        电话：{data.row.contractPhone}
                                    </li> 
                                </ul>
                            )
                        }
                        
                    }
                },

                {
                    minWidth:210,
                    prop: "tsCount",
                    label: "消费时间戳总数",
                },
                {
                    minWidth:210,
                    prop: "sourceTypeName",
                    label: "消费平台",
                },
            ],
            total: 10,
            pickerOptions: {
              shortcuts: [{
                text: '最近一周',
                onClick(picker) {
                  const end = new Date();
                  const start = new Date();
                  start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                  picker.$emit('pick', [start, end]);
                }
              }, {
                text: '最近一个月',
                onClick(picker) {
                  const end = new Date();
                  const start = new Date();
                  start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                  picker.$emit('pick', [start, end]);
                }
              }, {
                text: '最近三个月',
                onClick(picker) {
                  const end = new Date();
                  const start = new Date();
                  start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                  picker.$emit('pick', [start, end]);
                }
              }]
            },
            spanArr: [],
        };
    },

    components: {
        ExTable,
    },

    computed: {
        channelCodeValue(){
            return this.$store.state.config.channelCodeValue;
        },
    },

    created() {
        this.getTableData(filterParams(this.searchParam))
        this.getTsCount(filterParams(this.searchParam))
    },

    mounted() {
        zhuge.track('用户中心_子账号申请统计', {'渠道': this.channelCodeValue})
    },

    methods: {
        async getTsCount(data) {
            let res = await getConsumeTsCount(data);
            console.log(res)
            this.tsCount=res.tsCount
        },

        async getTableData(data) {
            let res = await getChildrenOverview(data);
            console.log(res)
            this.tableData =res.data.slice((this.page - 1) * this.size, (this.page - 1) * this.size + this.size);
            this.total=res.total;
            let contactDot = 0;
            this.spanArr=[];
            this.tableData.forEach( (item,index) => {
                if(index===0){
                    this.spanArr.push(1)
                }else{
                    if(item.username === this.tableData[index-1].username){
                        this.spanArr[contactDot] += 1;
                        this.spanArr.push(0)
                    }else{
                        contactDot = index
                        this.spanArr.push(1)
                    }
                }
            })
        },
        selectTable(){
            // if(this.searchParam.username){
            //     let reg = /^(?![0-9]+$)(?![a-zA-Z]+$)((?!@))[0-9A-Za-z-_]{2,32}$/;
            //     if (!reg.test(this.searchParam.username)) {
            //         this.$msg('请输入32位内数字+字母或符号组合，不允许输入非法字符如：()*&^%$#@','error', 8000)
            //         return 
            //     }
            // }
            this.page=1;
            this.getTableData(filterParams(this.searchParam));
        },
        clickPage(page){
            this.page=page;
            this.getTableData(filterParams(this.searchParam));
        },
        clickSize(size){
            this.page=1;
            this.size=size;
            this.pageSizeNum=size;
            this.getTableData(filterParams(this.searchParam));
        },
        datetime(e) {
            if (e) {
                this.searchParam.startCreatedAt = e[0];
                this.searchParam.endCreatedAt = e[1];
            } else {
                this.searchParam.startCreatedAt = "";
                this.searchParam.endCreatedAt = "";
            }
        },
        tableSpanMethod({ row, column, rowIndex, columnIndex }){
            if(columnIndex ===0 || columnIndex ===1 || columnIndex ===2){
                if(this.spanArr[rowIndex]){
                    return {
                        rowspan:this.spanArr[rowIndex],
                        colspan:1
                    }
                }else{
                    return {
                        rowspan: 0,
                        colspan: 0
                    }
                }
            }
        }
    },
};
</script>
<style lang="less" scoped>
.search{
    padding-top:20px;
}
.operation{
    text-align: right;
    span{
        display: inline-block;
        cursor: pointer;
        color:#3f7df7;
        font-size: 14px;
        line-height: 40px;
        margin-left: 20px;
        i{
            display: inline-block;
            margin-right: 5px;
        }
    }
}
</style>